

































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { createDigitsArr } from '@/tools/counters';

interface FillColorStyle {
  fill: string;
}

enum fillColors {
  HOT = '#E53935', // Red700
  COLD = '1976D2', // Blue700
}

@Component
export default class WaterCounterSvg extends Vue {
  @Prop({ required: true }) private Digits!: string;

  @Prop({ required: true }) private Unit!: string;

  @Prop({ default: 'м³' }) private Metric!: string;

  @Prop({ default: false }) private isCold!: boolean;

  private readonly DigitsArr: Array<string> = createDigitsArr(this.Digits);

  get FillColor(): FillColorStyle {
    return {
      fill: this.isCold ? fillColors.COLD : fillColors.HOT
    } as FillColorStyle;
  }
}
